import { compose } from "recompose";
import { connect } from "react-redux";
import { getPresence, getStatus, getVideoQuality } from "src/duck/selectors";
import { getPairedDevices } from "src/modules/device/duck/selectors";
import { withMessenger } from "src/modules/messenger/Provider";
import { withPurchase } from "src/modules/purchase/PurchaseContext";
import { withApp } from "src/components/App/Context";
import { hasPremium } from "src/modules/auth/duck/selectors";
import {
  getDefaultAvatar,
  getAvatars
} from "src/modules/avatar/duck/selectors";
import { getIsInDetachMode } from "src/duck/selectors";
import { setDefaultAvatar } from "src/modules/avatar/duck/actions";
import { appFailure } from "src/duck/actions";

import ParentStation from "./ParentStation";
import useParentStationLullabyPlayer from "src/modules/lullaby/useParentStationLullabyPlayer";
import environment from "src/utils/environment";

function ParentStationUsingLullabyPlayer(props) {
  return (
    <ParentStation
      {...props}
      lullabyPlayers={{
        0: useParentStationLullabyPlayer(),
        1: useParentStationLullabyPlayer(),
        2: useParentStationLullabyPlayer(),
        3: useParentStationLullabyPlayer()
      }}
    />
  );
}

function mapStateToProps(state) {
  return {
    stationsByJid: getPairedDevices(state),
    presence: getPresence(state),
    defaultAvatar: getDefaultAvatar(state),
    hasPremium: hasPremium(state),
    micSensitivity: "MS_MEDIUM",
    appStatus: getStatus(state),
    videoQuality: getVideoQuality(state),
    isInDetachMode: getIsInDetachMode(state),
    allAvatars: Object.values(getAvatars(state))
      .filter((avatar) => avatar.deleted === false)
      .reduce((all, avatar) => {
        all[avatar.objectId] = avatar;
        return all;
      }, {})
  };
}

const enhance = compose(
  withPurchase,
  withMessenger,
  withApp,

  connect(mapStateToProps, {
    setDefaultAvatar,
    appFailure
  })
);

export default enhance(
  environment.supportsLullabies
    ? ParentStationUsingLullabyPlayer
    : ParentStation
);
